<!-- Loading bar -->
<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>
<ng-container *transloco="let t; read: 'layout'">
    <!-- Navigation -->
    <fuse-vertical-navigation
        [mode]="isScreenSmall ? 'over' : 'side'"
        [name]="'mainNavigation'"
        [navigation]="navigation.default"
        [opened]="!isScreenSmall"
        class="dark bg-gray-900 print:hidden">
        <!-- Navigation header hook -->
        <ng-container fuseVerticalNavigationContentHeader>
            <div class="flex items-center w-full p-4 pl-6">
                <!-- Logo -->
                <div class="flex items-center justify-center">
                    <img
                        class="w-8"
                        src="assets/logo/logo_single.svg">
                </div>
                <!-- Components -->
                <div class="flex items-center ml-auto">
                    <user [showAvatar]="false"></user>
                </div>
            </div>
            <!-- User -->
            <div class="flex flex-col items-center w-full p-4">
                <div
                    class="group relative w-24 h-24 rounded-full overflow-hidden ring-2 ring-white ring-opacity-10 focus-within:ring-primary-400">
                    <img
                        [src]="this.avatarURL ?? 'assets/illustrations/profile_pic/default/undraw_profile_pic.svg'"
                        alt="User avatar"
                        class="w-full h-full rounded-full object-cover">
                    <input
                        #sidebarAvatarFileInput
                        (change)="onAvatarFileSelected(sidebarAvatarFileInput.files, sidebarAvatarFileInput)"
                        [accept]="'image/jpeg, image/png, image/webp'"
                        [multiple]="false"
                        class="absolute h-0 w-0 opacity-0 invisible pointer-events-none"
                        type="file">
                    <div
                        class="absolute inset-0 z-10 flex items-center justify-center rounded-full bg-black bg-opacity-55 opacity-0 transition-opacity duration-150 group-hover:opacity-100 group-focus-within:opacity-100"
                        [ngClass]="{'opacity-100': this.uploadingAvatar}">
                        <mat-progress-spinner
                            *ngIf="this.uploadingAvatar"
                            [diameter]="34"
                            [mode]="'indeterminate'"
                            class="text-white">
                        </mat-progress-spinner>
                        <div *ngIf="!this.uploadingAvatar" class="flex items-center justify-center gap-1">
                            <button
                                *ngIf="this.avatarURL"
                                (click)="openAvatarPreview($event)"
                                [attr.aria-label]="'Profilbild vergrößern'"
                                mat-icon-button
                                matTooltip="Profilbild vergrößern"
                                type="button">
                                <mat-icon
                                    [svgIcon]="'heroicons_outline:eye'"
                                    class="text-white"></mat-icon>
                            </button>
                            <button
                                (click)="sidebarAvatarFileInput.click()"
                                [attr.aria-label]="'Profilbild ändern'"
                                mat-icon-button
                                matTooltip="Profilbild ändern"
                                type="button">
                                <mat-icon
                                    [svgIcon]="'heroicons_outline:camera'"
                                    class="text-white"></mat-icon>
                            </button>
                        </div>
                    </div>
                    <!--				<mat-icon-->
                    <!--						*ngIf="!this.firebaseUser?.avatar?.url"-->
                    <!--						[svgIcon]="'heroicons_solid:user-circle'"-->
                    <!--						class="icon-size-24"></mat-icon>-->
                </div>
                <div class="flex flex-col items-center justify-center w-full mt-6">
                    <ng-container *ngIf="(this.authUser$ | async) as user">
                        <div @zoomIn
                             class="w-full whitespace-nowrap text-ellipsis overflow-hidden text-center leading-normal font-medium">
                            {{ user?.displayName }}
                            <!--					{{this.firebaseUser?.displayName || (this.firebaseUser?.firstName + ' ' + this.firebaseUser?.lastName) }}-->
                        </div>
                        <div
                            class="w-full mt-0.5 whitespace-nowrap text-ellipsis overflow-hidden text-center text-md leading-normal font-medium text-secondary">
                            <!--					{{this.firebaseUser?.email}}-->
                            {{ user?.email }}
                        </div>
                    </ng-container>
                    <ng-container *ngIf="this.role$ | async as role; else trialOver">
                        <ng-container [ngSwitch]="role">
                            <div *ngSwitchCase="'STARTER'" @zoomIn
                                 class=" mt-2 px-2 bg-blue-600 text-on-warn rounded font-semibold">
                                {{ role }}
                            </div>
                            <div *ngSwitchCase="'PRO'" @zoomIn
                                 class=" mt-2 px-2 bg-primary text-on-primary rounded font-semibold">
                                {{ role }}
                            </div>
                            <div *ngSwitchCase="'ENTERPRISE'" @zoomIn
                                 class=" mt-2 px-2 bg-accent text-on-accent rounded font-semibold">
                                {{ role }}
                            </div>
                            <div *ngSwitchDefault @zoomIn class=" mt-2 px-2 bg-green-600 text-on-warn rounded">
                                {{ t('free') }}
                            </div>

                        </ng-container>
                        <!--					<div class=" mt-2 px-2 bg-green-600 text-on-warn rounded">-->
                        <!--						Kostenlos-->
                        <!--					</div>-->
                    </ng-container>
                    <ng-template #trialOver>
                        <div @zoomIn
                             class=" mt-2 px-2 bg-red-200 text-red-800 dark:bg-red-600 dark:text-red-50 rounded font-semibold">
                            {{ t('trialExpired') }}
                        </div>
                    </ng-template>
                    <div *ngIf="this.trialSubscription && !this.willTrialBeExtended" @zoomIn
                         class="w-full whitespace-nowrap text-ellipsis overflow-hidden text-center leading-normal font-medium mt-4">
                        <ng-container *ngIf="this.trialSubscription?.trial_end | toDate as trialEnd">
						<span *ngIf="this.trialDaysLeft as daysLeft"
                              class="font-extrabold">Noch {{ daysLeft }} {{
                                daysLeft | i18nPlural: {
                                    '=0': 'Tage',
                                    '=1': 'Tag',
                                    'other': 'Tage'
                                }
                            }}</span>
                        </ng-container>
                    </div>
                    <ng-container *ngIf="this.authUser$ | async as user">
                        <div *ngIf="!user.emailVerified"
                             @zoomIn @zoomOut
                             class="w-full mt-4">
                            <fuse-alert type="warning">
                                <span fuseAlertTitle>Konto nicht verifiziert</span>
                                <div class="flex flex-col space-y-4 w-full">
                                    <p>Um alle Funktionen von nahaus.de nutzen zu können, müssen Sie Ihre E-Mail-Adresse
                                        bestätigen.</p>
                                    <!-- CTA -->
                                    <button [disabled]="this.sendingVerificationLink"
                                            mat-raised-button
                                            color="accent"
                                            class="mt-3 -ml-6"
                                            (click)="sendVerificationLink()"
                                    >
                                        @if (!this.sendingVerificationLink) {
                                            <span>Verifizierungslink senden</span>
                                        }
                                        @if (this.sendingVerificationLink) {
                                            <mat-progress-spinner
                                                [diameter]="24"
                                                [mode]="'indeterminate'"
                                            ></mat-progress-spinner>
                                        }
                                    </button>
                                </div>
                            </fuse-alert>
                        </div>
                    </ng-container>
                </div>
            </div>
        </ng-container>
        <!-- Navigation footer hook -->
        <ng-container fuseVerticalNavigationContentFooter>
            <div
                class="flex flex-0 flex-col items-center justify-center px-6 pt-3 pb-4 mt-2 border-t border-white border-opacity-10">
                <img
                    alt="nahaus.de"
                    class="w-36 max-w-full opacity-80 mb-2"
                    src="assets/logo/logo_light_2.svg">
                <div
                    [attr.aria-label]="'Aktuelle App-Version ' + (this.env?.version || '-')"
                    [matTooltip]="'Aktuelle App-Version: ' + (this.env?.version || '-')"
                    class="inline-flex items-center mt-2.5 px-2.5 py-2 space-x-1.5 rounded border border-white border-opacity-10 bg-white bg-opacity-5 text-xs font-medium leading-none text-gray-200"
                    matTooltipPosition="above">
                    <mat-icon class="icon-size-4 text-gray-400">info_outline</mat-icon>
                    <span>Version {{ this.env?.version || '-' }}</span>
                </div>
            </div>
        </ng-container>
    </fuse-vertical-navigation>

    <!-- Wrapper -->
    <div class="flex flex-col flex-auto w-full min-w-0">

        <!-- Header -->
        <div
            class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
            <!-- Navigation toggle button -->
            <button
                (click)="toggleNavigation('mainNavigation')"
                mat-icon-button>
                <mat-icon [svgIcon]="'mat_outline:menu'"></mat-icon>
            </button>

            <!--		<ng-container *ngIf="this.tier$ | async as tier">-->
            <!--			<a *ngIf="tier !== 'PRO' && tier !== 'ENTERPRISE'" class="ml-2" color="primary" mat-raised-button-->
            <!--			   routerLink="/upgrade">-->
            <!--				Upgrade-->
            <!--			</a>-->
            <!--		</ng-container>-->

            <ng-container *ngIf="this.env?.pool">
                <ng-container *ngIf="this.tier$ | async as tier; else trialOverAlert">
                    <!--	if trial end date exists on a subscription-->
                    <!-- Info -->
                    <fuse-alert *ngIf="this.trialSubscription" @zoomIn [type]="'info'" class="hidden sm:block ml-2">
                        <ng-container *ngIf="this.trialSubscription?.trial_end | toDate as trialEnd">
						<span fuseAlertTitle>Sie befinden sich momentan in einer Testversion unserer <span
                            class="font-extrabold">{{ this.trialSubscription?.role || 'PRO' }}</span>-Version<span
                            *ngIf="!this.willTrialBeExtended">, die am {{ trialEnd  | date:'shortDate' }}
                            endet
						<span *ngIf="this.trialDaysLeft as daysLeft"
                              class="font-extrabold">(noch {{ daysLeft }} {{
                                daysLeft | i18nPlural: {
                                    '=0': 'Tage',
                                    '=1': 'Tag',
                                    'other': 'Tage'
                                }
                            }})</span>.</span></span>
                        </ng-container>
                    </fuse-alert>
                    <button
                        *ngIf="this.shouldShowTrialActivationCta"
                        (click)="goToTrialActivationPricing()"
                        class="ml-2 flex-shrink-0 whitespace-nowrap"
                        color="primary"
                        mat-flat-button
                        type="button">
                        <mat-icon class="mr-1 icon-size-4">rocket_launch</mat-icon>
                        <span class="hidden sm:inline">Jetzt aktivieren</span>
                        <span class="sm:hidden">Aktivieren</span>
                    </button>

                    <ng-container
                        *ngIf="this.trialSubscription && !this.willTrialBeExtended && !this.shouldShowTrialActivationCta && this.trialSubscription.role !== this.tiersOptions.ENTERPRISE && this.isMasterUser">
                        <a @zoomIn class="ml-2" color="primary"
                           mat-raised-button routerLink="/upgrade">
                            {{ t('subscribeToProVersion') }}
                        </a>
                    </ng-container>

                </ng-container>
            </ng-container>

            <ng-template #trialOverAlert>

                <!-- Info -->
                <fuse-alert @zoomIn [type]="'error'" class="hidden sm:block ml-2">
                    <span fuseAlertTitle>{{ t('proTrialExpired') }}</span>
                </fuse-alert>


                <ng-container *ngIf="this.isMasterUser">
                    <a @zoomIn class="ml-2" color="warn"
                       mat-raised-button routerLink="/upgrade">
                        {{ t('subscribeToProVersion') }}
                    </a>
                </ng-container>
            </ng-template>

            <!-- Components -->
            <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
                <languages *ngIf="!this.env?.production"></languages>
                <global-search></global-search>
                <!--                <search-old *ngIf="!this.env?.production" [appearance]="'bar'"></search-old>-->
                <shortcuts-old *ngIf="!this.env?.production"></shortcuts-old>
                <!--                <messages-old *ngIf="!this.env?.production"></messages-old>-->
                <notifications></notifications>

                <button mat-icon-button [routerLink]="['/kalender']"
                        matTooltip="Kalender">
                    <mat-icon>calendar_today</mat-icon>
                </button>

                <!-- <button
                    mat-icon-button
                    (click)="tutorialService.toggleTutorial()"
                    matTooltip="Tutorial / Hilfe anzeigen"
                    class="hover:bg-blue-100 dark:hover:bg-blue-900 text-blue-600">
                    <mat-icon
                        [svgIcon]="'heroicons_outline:light-bulb'"
                        class="icon-size-6">
                    </mat-icon>
                </button> -->

                <!--                <button (click)="quickChat.toggle()"-->
                <!--                        *ngIf="!this.env?.production && this.env?.showQuickChat"-->
                <!--                        class="lg:hidden"-->
                <!--                        mat-icon-button>-->
                <!--                    <mat-icon [svgIcon]="'heroicons_outline:chat-alt-2'"></mat-icon>-->
                <!--                </button>-->
                <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            </div>
        </div>

        <div *ngIf="this.pastDueSubscription"
             @zoomIn
             class="print:hidden border-b border-amber-200 bg-amber-50 px-4 py-3 text-amber-900 dark:border-amber-700 dark:bg-amber-950 dark:text-amber-50">
            <div
                class="mx-auto flex w-full max-w-screen-2xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <div class="flex min-w-0 items-start gap-3">
                    <mat-icon class="mt-0.5 text-amber-600 dark:text-amber-300">credit_card_off</mat-icon>
                    <div class="min-w-0">
                        <div class="font-semibold leading-5">Zahlung fehlgeschlagen</div>
                        <div class="text-sm leading-5">
                            Ihr Abonnement ist aktuell überfällig. Bitte aktualisieren Sie die Zahlungsmethode, damit
                            der Zugang nicht eingeschränkt wird.
                        </div>
                    </div>
                </div>
                <div class="flex shrink-0 items-center gap-2 sm:ml-4">
                    <button *ngIf="this.isMasterUser"
                            (click)="sendToCustomerPortal()"
                            color="primary"
                            mat-flat-button>
                        Zahlungskonto öffnen
                    </button>
                    <span *ngIf="!this.isMasterUser"
                          class="text-sm font-medium">
                        Bitte informieren Sie den Administrator.
                    </span>
                </div>
            </div>
        </div>

        <!-- Content -->
        <div class="flex flex-col flex-auto">
            <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
                 Otherwise, layout changes won't be registered and the view won't be updated! -->
            <router-outlet *ngIf="true"></router-outlet>
        </div>

        <!-- Footer -->
        <!--	<div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">-->
        <!--		<span class="font-medium text-secondary">Nahaus.de &copy; {{currentYear}}</span>-->
        <!--	</div>-->

    </div>

    <!-- Quick chat -->
    <quick-chat #quickChat="quickChat"></quick-chat>
</ng-container>
